<div class="modal fade show" [class.expanded]="isExpanded()" tabindex="-1" aria-labelledby="impersonation-picker-title"
  aria-hidden="false" style="display: block">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex w-100">
          <div class="me-2 id flex-fill">
            <h4 class="modal-title mb-0 item-id" id="impersonation-picker-title">Impersonate a user</h4>
          </div>
          <div class="btns-header">
            <button class="header-icon close p-0 m-0" (click)="close()" [disabled]="!!busy()" aria-label="Close">
              <i class="fas fa-times" title="Close Popup"></i>
            </button>
            <button class="close header-icon expand-modal p-0 m-0" (click)="expandCollapse()">
              <i class="fas ms-2 me-2" [class.fa-expand-alt]="!isExpanded()" [class.fa-compress-alt]="isExpanded()"
                [title]="isExpanded() ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body pt-0">
        <p class="small text-muted mt-2 mb-1">
          Dev, Test and Stage only. You work as the user you pick, with their rights, until you stop (or the time shown in the
          yellow pill at the top); what you change is saved under their name (WebAuth records that it was you). Stop
          from the pill or the user menu.
        </p>
        @if (error()) {
          <div class="alert alert-danger py-1 px-2 mb-1" role="alert">{{ error() }}</div>
        }
        @if (busy()) {
          <div class="alert alert-info py-1 px-2 mb-1" role="status">{{ busy() }}</div>
        }
        <div class="search-grid p-2 mt-1" style="height: 480px">
          <inavista-grid
            [config]="gridConfig"
            [actionIcons]="actionIcons"
            (actionIconClick)="onActionIconClick($event)"
            (hyperlinkClick)="onHyperlinkClick($event)" />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()" [disabled]="!!busy()">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show"></div>
